import throttle from 'lodash/throttle'
import * as React from 'react'
import Measure from 'react-measure'

import type { LinkViewModel } from '../../view-models/LinkViewModel'
import scrollToElement from '../../utils/ScrollToElement'
import BaseButton from '../BaseButton/BaseButton'
import styles from './anchorPointsDesktop-style.css'

type Props = {
  anchorPoints: LinkViewModel[]
  isDesktop?: boolean | null
}
type State = {
  activeIndex: number | null
  width: number
  transformLeft: number
  offsetsElementsArray: any[]
  offsetsLeftArray: any[]
}

class AnchorPointsDesktop extends React.Component<Props, State> {
  static displayName = 'AnchorPointsDesktop'
  static defaultProps = {}
  state = {
    activeIndex: null,
    width: 0,
    transformLeft: 0,
    offsetsElementsArray: [],
    offsetsLeftArray: [],
  }
  throttledFunction = throttle(() => this.calculateOffsets(), 150)

  componentDidMount() {
    this.addScrollListener()
    this.calculateModulePositions()
    setTimeout(() => this.calculateOffsets(), 1000) //fire after DOM renders (estimate)

    setTimeout(() => this.setMutationObserver(), 1500) // dont fire it straight away
  }

  addScrollListener = () => window.addEventListener('scroll', this.throttledFunction)
  removeScrollListener = () => window.removeEventListener('scroll', this.throttledFunction)
  setMutationObserver = () => {
    // watch for any changes in the body, and recalculate height if they appear
    const targetNode = document.body
    const observerOptions = {
      childList: false,
      attributes: true,
      subtree: true,
    }
    const observer = new MutationObserver(() => this.calculateModulePositions())

    if (targetNode) {
      return observer.observe(targetNode, observerOptions)
    }
  }
  calculateModulePositions = () => {
    const { anchorPoints } = this.props
    // find position of the elements on the page and put them into a state
    const offsetsElementsArray: any[] =
      anchorPoints &&
      anchorPoints.map((el: LinkViewModel) => {
        let moduleOffsets: number[] = []

        if (el && el.href) {
          const domEl = document.getElementById(el.href)

          if (domEl) {
            const top: number =
              domEl.getBoundingClientRect().top - 130 + window.scrollY ||
              (document.documentElement && document.documentElement.scrollTop)
            const bot: number =
              domEl.getBoundingClientRect().bottom + window.scrollY ||
              (document.documentElement && document.documentElement.scrollTop)
            moduleOffsets.push(top)
            moduleOffsets.push(bot)
          }
        }

        return moduleOffsets
      })
    this.setState({
      offsetsElementsArray,
    })
  }
  calculateOffsets = () => {
    const { offsetsElementsArray, offsetsLeftArray } = this.state as State
    const { anchorPoints } = this.props
    const arr: boolean[] = []
    offsetsLeftArray?.length === offsetsElementsArray.length &&
      //TODO: any
      offsetsElementsArray?.map(([a, b]: any, i) => {
        const x = window.pageYOffset
        // check if window.pageYOffset is within the position of modules
        const inView = (x - a) * (x - b) <= 0

        // if it is, update local state
        if (inView) {
          this.setState({
            activeIndex: i,
            transformLeft: offsetsLeftArray[i].left,
            width: offsetsLeftArray[i].width,
          })

          if (window.history.pushState && anchorPoints) {
            window.history.pushState(null, '', `#${anchorPoints[i].href || ''}`)
          }
        }

        arr.push(inView)

        return arr
      })
    const found = arr.find((el) => el)

    // if user scrolls away from article, and neither anchor point is active
    if (!found && window.history.pushState) {
      window.history.pushState(null, '', '#')
    }
  }
  handleClick = (i: number, { offset }: any, id: string) => {
    //remove the scroll event for the time of the click event
    this.removeScrollListener()
    this.setState({
      activeIndex: i,
      width: offset.width,
      transformLeft: offset.left,
    })
    scrollToElement(id, 100)
    // add scroll event back after scrollToElement is done
    setTimeout(() => {
      this.addScrollListener()

      // add id to url without jumping
      if (window.history.pushState) {
        window.history.pushState(null, '', `#${id}`)
      }
    }, 401)
  }

  componentWillUnmount() {
    this.removeScrollListener()
    //clean up
    this.setState = () => {
      return;
    };
  }

  render() {
    const { anchorPoints, isDesktop } = this.props
    const { activeIndex, width, transformLeft } = this.state
    const eventMeta = {
      event: 'anker-menu-interaction',
    }
    if (!anchorPoints || !isDesktop) return null

    return (
      <div className={styles.ulHolder}>
        <ul className={styles.ul}>
          <div
            className={styles.bar}
            style={{
              width,
              transform: `translate3d(${transformLeft}px, 0px, 0px)`,
            }}
          />
          {anchorPoints.map((point, i) => {
            return (

              point.label && point.href ? <Measure
                offset
                key={point.label}
                onResize={(contentRect) => {
                  let newArr: { left: number; width: number }[] = this.state.offsetsLeftArray
                  newArr[i] = {
                    left: contentRect.offset.left,
                    width: contentRect.offset.width,
                  }
                  this.setState({
                    offsetsLeftArray: newArr,
                    transformLeft: contentRect.offset.left,
                  })
                }}
              >
                {({ measureRef, contentRect }) => {
                  return (
                    <li ref={measureRef} className={activeIndex === i ? styles.active : ''}>
                      <BaseButton
                        className={styles.anchorPoint}
                        onClick={() => this.handleClick(i, contentRect, point.href || '')}
                        isAnchor={false}
                        eventMeta={eventMeta}
                      >
                        {point.label}
                      </BaseButton>
                    </li>
                  )
                }}
              </Measure>: null
            )
          })}
        </ul>
      </div>
    )
  }
}

export default AnchorPointsDesktop